import { JsonModel, Model } from './model'

export class SupplierSubstatus extends Model {
    public static WAITING_FOR_PAYMENT = 2;
    public static PAYMENT_PLAN = 4;
    public static INVOICE_1 = 5;
    public static INVOICE_2 = 6;
    public static INVOICE_3 = 7;
    public static INTERNATIONAL_COLLECTIONS = 9;
    public static NEW = 10;
    public static ASSIGNED = 11;
    public static ON_HOLD = 12;

    code: number
    name: string

    constructor(json: JsonSupplierSubstatus) {
        super(json)

        this.code = json.code
        this.name = json.name
    }
}

export interface JsonSupplierSubstatus extends JsonModel {
    code: number
    name: string
}
